import { Outlet, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

export const Route = createFileRoute('/_app/dashboard')({
  component: DashboardLayout,
});

function DashboardLayout(): React.ReactElement {
  return <Outlet />;
}
